<div *ngIf="status$ | async as status" style="display: flex; flex-direction: column; height: calc(100% - 50px);">
	<button id="co-pilot-hidden-button" style="visibility: hidden;" (click)="onPanelResizing()"></button>
	<div *ngIf="status === 'initializing'" class="loading-spinner"></div>
	<div *ngIf="status !== 'initializing'" class="prompt-container">
		<div class="prompt-input" #inputWrapper>
			<div *ngIf="!showPromptControl" class="prompt-textarea" (click)="togglePromptControl()">{{selectedPrompt.title}}</div>
			<textarea *ngIf="showPromptControl" class="prompt-textarea" [formControl]="promptControl" cdkTextareaAutosize #autosize="cdkTextareaAutosize" [cdkAutosizeMinRows]="1" [cdkAutosizeMaxRows]="15"
					  (keydown.enter)="enterPrompt($event)" placeholder="Ask a question about the current document." [matAutocomplete]="auto"></textarea>
			<div class="prompt-enter">
				<button *ngIf="isLoading" (click)="cancelRequest()">
					<div style="display: flex; justify-items: center; gap: 10px;">
						<span>click to cancel</span>
						<i class="fa-solid fa-ban" style="font-size: 16px;"></i>
					</div>
				</button>
				@if(!isLoading) {
				<button style="padding-right: 0px;" *ngIf="showClearButton()" (click)="clearPrompt()">
					<i class="fa-solid fa-times" style="font-size: 16px;"></i>
				</button>
				<div style="height: 100%; width: 1px; background: #595959;"></div>
				<button class="prompt-enter-button" [disabled]="promptControl?.value?.length === 0 || showTokenError" (click)="enterPrompt($event)">
					<i class="fa-solid fa-arrow-turn-down-left" style="font-size: 16px;"></i>
				</button>
				}
			</div>
		</div>
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPromptChange($event)" [panelWidth]="inputWrapper.offsetWidth" [displayWith]="displayFn">
			<mat-option *ngFor="let prompt of localPrompts" [value]="prompt" class="prompt-item" [ngClass]="{'dark-theme': isDarkMode()}" (mouseenter)="hoverPromptId = prompt.promptId" (mouseleave)="hoverPromptId = null">
				<lex-prompt-item [prompt]="prompt" [canDelete]="prompt.createdById === currentUserId" [isHovering]="hoverPromptId === prompt.promptId"></lex-prompt-item>
			</mat-option>
		</mat-autocomplete>
		<mat-hint class="warning-hint" *ngIf="showTokenWarning && !showTokenError"><mat-icon class="hint-icon">info</mat-icon> Current prompt could potentially exceed the maximum token limit</mat-hint>
		<mat-hint class="error-hint" *ngIf="showTokenError"><mat-icon class="hint-icon">info</mat-icon> Current prompt exceeds the maximum token limit</mat-hint>
	</div>
	<div style="flex-grow: 1;overflow: auto; min-height: 50px; max-height: 450px; height: calc(100% - 50px)" *ngIf="response$ | async as response" #scrollResult>
		<lex-prompt-response *ngIf="response?.length > 0" [responseText]="response" [isLoading]="isLoading"></lex-prompt-response>
		@if (isLoading) {
		<div style="display: flex; justify-content: center; height: 15px; width: 100%; padding: 20px 0;">
			<div class="dot-pulse"></div>
		</div>
		}

		<div *ngIf="!isLoading && showContinue" class="center-button">
			<button (click)="goToNextChunk()" mat-flat-button class="continue-button" style="display: block; margin: 16px auto; font-weight: 400;">Continue</button>
		</div>
		<div *ngIf="!isLoading && showRetry" class="center-button">
			<button (click)="retry()" mat-flat-button class="co-pilot-button" style="display: block; margin: 16px auto; font-weight: 400;">Retry</button>
		</div>
	</div>
</div>